import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import {
  setStateChangedInfo,
  setUserInfo,
  updateUserInfo,
} from "../actionCreators";
import { userInfoPLACEHOLDER, UserInformationReducer } from "../types";

const initialState: UserInformationReducer = { ...userInfoPLACEHOLDER };

const informationReducer = reducer(
  initialState,
  on(setUserInfo, (state, { payload: { userInfo } }) => ({
    ...state,
    ...userInfo,
    stateChanged: false,
  })),
  on(updateUserInfo, (state, { payload: { userInfo } }) => ({
    ...state,
    ...userInfo,
    stateChanged: true,
  })),
  on(setStateChangedInfo, (state, { payload: { newState } }) => {
    state.stateChanged = newState;
  })
);

export default informationReducer;
